<script>
import Datatable from "@/router/layouts/table-datatable.vue";
// import Pagination from "@/router/layouts/table-pagination.vue";
import axios from "axios";
import Swal from "sweetalert2";
import ModalEditTresholdNilai from "./modal-edit-treshold-nilai.vue";

export default {
  props: ["status_jadwal"],
  components: {
    Datatable,
    ModalEditTresholdNilai,
    // Pagination,
  },
  data() {
    let sortOrders = []; // select sortOrder

    // definisi kolom yang dipakai
    let columns = [
      {
        width: "50px",
        label: "No",
        name: "-",
      },
      {
        label: "Level Kompetensi",
        name: "-",
      },
      {
        width: "auto",
        label: "Nilai Esai",
        name: "-",
      },
      {
        width: "auto",
        label: "Treshold Dari",
        name: "-",
      },
      {
        width: "auto",
        label: "Treshold Sampai",
        name: "-",
      },
      {
        width: "170px",
        label: "Aksi",
        name: "-",
      }, // jika tidak ada sorting kasih name dengan karakter -
    ];

    // cek sorting
    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });

    return {
      title: "Jadwal Pelaksanaan",
      showModalEditTresholdNilai: false,
      jadwal_id: this.$route.params.id,
      selected_row: {},
      loadingTable: true,
      table_data: [],
      columns: columns,
      sortKey: "idjadwal_treshold_nilai",
      sortOrders: sortOrders,
      currentTablePage: "",

      // parsing data ke table data
      tableData: {
        draw: 0,
        length: 10,
        search: "",
        column: 0,
        dir: "asc",
        filter_status: "all", // untuk filtering data
      },
    };
  },
  methods: {
    getDataTable() {
      this.loadingTable = true;
      this.tableData.draw++;
      let config = {
        method: "get",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          `master/jadwal-pelaksanaan/${this.jadwal_id}/setup-jadwal/jadwal-treshold-nilai`,
        params: this.tableData,
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      };
      axios(config)
        .then((response) => {
          let response_data = response.data;
          if (response_data.meta.code == 200) {
            this.table_data = response_data.data;
          } else {
            Swal.fire({
              icon: "error",
              title: "Gagal",
              text: response_data.meta.message,
            });
          }
          this.loadingTable = false;
        })
        .catch((error) => {
          this.loadingTable = false;
          console.error(error);
        });
    },
    editTresholdNilai(item) {
      this.selected_row = {};
      this.selected_row = { ...item };
      this.selected_row.treshold_dari = item.treshold_dari ?? 0;
      this.selected_row.treshold_sampai = item.treshold_sampai ?? 0;
      this.showModalEditTresholdNilai = true;
    },
    reset(row) {
      Swal.fire({
        title: "Konfirmasi",
        text: "Apakah Anda yakin ingin mengatur ulang nilai treshold?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Iya",
        cancelButtonText: "Batal",
      }).then((result) => {
        if (result.isConfirmed) {
          if (row.idjadwal_treshold_nilai == null) {
            Swal.fire({
              icon: "success",
              title: "Berhasil",
              text: "Data berhasil diatur ulang.",
            });
            return;
          }
          
          this.loadingTable = true;
          let config = {
            method: "delete",
            url:
              process.env.VUE_APP_BACKEND_URL_VERSION +
              `master/jadwal-pelaksanaan/${this.jadwal_id}/setup-jadwal/jadwal-treshold-nilai/${row.idjadwal_treshold_nilai}`,
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          };

          axios(config)
            .then((response) => {
              let response_data = response.data;
              if (response_data.meta.code == 200) {
                Swal.fire({
                  icon: "success",
                  title: "Berhasil",
                  text: response_data.meta.message,
                });
                this.getDataTable();
              } else {
                Swal.fire({
                  icon: "error",
                  title: "Gagal",
                  text: response_data.meta.message,
                });
              }
            })
            .catch((error) => {
              console.error(error);
            })
            .finally(() => {
              this.loadingTable = false;
            });
        }
      });
    }
  },
  mounted() {
    this.getDataTable();
  },
};
</script>
<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col">
              <div class="card-title">Konfigurasi Timer dan Jumlah Soal</div>
            </div>
            <datatable :columns="columns">
              <tbody>
                <tr v-if="loadingTable">
                  <td colspan="6" class="text-center">
                    <!-- <div class="spinner-border text-primary" role="status">
                      <span class="sr-only">Loading...</span>
                    </div> -->
                    <i class="fas fa-spinner fa-spin"></i> Loading...
                  </td>
                </tr>
                <tr v-else-if="table_data.length == 0">
                  <td colspan="6" class="text-center">Data tidak ditemukan</td>
                </tr>
                <tr v-else v-for="(item, index) in table_data" :key="index">
                  <td class="text-center">{{ index + 1 }}</td>
                  <td>{{ item.level_kompetensi.nama_level }}</td>
                  <td>{{ item.nilai_text }}</td>
                  <td>{{ item.treshold_dari ?? "0" }}</td>
                  <td>{{ item.treshold_sampai ?? "0" }}</td>
                  <td class="text-center">
                    <div class="btn-group btn-sm">
                      <button
                        class="btn btn-warning btn-sm"
                        @click="editTresholdNilai(item)"
                      >
                        <i class="fas fa-edit"></i>
                        Edit
                      </button>
                      <button
                        class="btn btn-danger btn-sm"
                        @click="reset(item)"
                      >
                        <i class="fas fa-undo"></i>
                        Reset
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </datatable>
          </div>
          <!-- <pagination :pagination="pagination" @to-page="toPage"></pagination> -->
        </div>
      </div>
    </div>
  </div>
  <b-modal
    v-model="showModalEditTresholdNilai"
    hide-footer
    title="Edit Jadwal Treshold Nilai"
  >
    <ModalEditTresholdNilai
      :selectedData="selected_row"
      :jadwal_id="jadwal_id"
      @submitTresholdNilai="
        showModalEditTresholdNilai = false;
        getDataTable();
      "
      @close="showModalEditTresholdNilai = false"
    />
  </b-modal>
</template>
